import { useEffect, useRef } from 'react';
import { PRIMARY_LANGUAGE_CODE } from '../../../shared/constants/languages.js';

export const LanguageOptions = ({ onSelect, label }) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current && onSelect) {
      isInitialized.current = true;
      onSelect(PRIMARY_LANGUAGE_CODE);
    }
  }, [onSelect]);

  return (
    <div>
      <label className="form-label">{label || 'Основной язык'}</label>
      <input className="form-control" value={`${PRIMARY_LANGUAGE_CODE} (русский)`} disabled />
      <div className="form-text">
        Основной язык теперь фиксированный: <strong>{PRIMARY_LANGUAGE_CODE}</strong>.
      </div>
    </div>
  );
};
